import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    gap: 14px;
    background-color: #EAF4FF;
    border-radius: 12px;
    padding: 18px 20px;
`;

export const IconCircle = styled.div`
    width: 34px;
    height: 34px;
    min-width: 34px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Content = styled.div`
    flex: 1;
    min-width: 0;
`;

export const Title = styled.h3`
    margin: 0 0 4px 0;
    font-family: Lato;
    font-size: 14px;
    font-weight: 700;
    color: ${theme.colors.gray.Cinza_2};
`;

export const Description = styled.p`
    margin: 0;
    font-family: Lato;
    font-size: 13px;
    color: ${theme.colors.gray.Cinza_6};
`;

export const LoadingBox = styled.div`
    width: 100%;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Link = styled.a`
    display: inline-block;
    margin-top: 8px;
    font-family: Lato;
    font-size: 13px;
    font-weight: 700;
    color: ${theme.colors.blue.Azul_link};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;
